import React, { useState } from 'react'
import { useLightboxModal } from '../../Hooks/useLightbox';

import './Lightbox.css'

export function Lightbox(props) {

	const [isOpen, setIsOpen] = useState(false)

	const { displayLightbox } = useLightboxModal();


	const onClick = () => {
		displayLightbox({
			image : props.image,
			onCancel : () => {}
		})
	}

	return (
		<div className='lightbox-content'>
			<img 
				src={props.thumbail} 
				// onClick={() => setIsOpen(!isOpen)} 
				onClick={ onClick }
				alt={props?.alt}/>
			{/* {
				isOpen && 
				<div className="lightbox-wrapper">
					<img src={props.image} alt={props?.alt}/>
				</div>
			} */}
		</div>	
	)
}
